<template>
	<VueApexChart
		v-if="chartOptions"
		class="app-chart-radar"
		:class="{ 'live' : autoUpdate }"
		type="radar"
		width="100%"
		height="100%"
		:options="chartOptions"
		:series="series"
		ref="chart"
	/>
</template>

<script>
export default {
	props: {
		title: [String, Array],
		plotSize: Number,
		autoUpdate: {
			type: Boolean,
			default: false
		},
		labels: {
			type: Array,
			required: true
		},
		series: {
			type: Array,
			default: () => []
		},

		noData: {
			type: String,
			default: 'No Data'
		}
	},

	created () {
		this.init()
	},

	watch: {
		async series () {
			this.updateLabels()
		},

		autoUpdate (val) {
			if (!this.$refs.chart) return
			this.$refs.chart.updateOptions({
				tooltip: { enabled: !this.autoUpdate },
				markers: { size: this.autoUpdate ? 0 : 2 },
				legend: {
					onItemHover: { highlightDataSeries: !this.autoUpdate },
					onItemClick: { toggleDataSeries: !this.autoUpdate }
				}
			})
		}
	},

	data () {
		return {
			chartOptions: null,
			hiddenSeries: []
		}
	},

	methods: {
		getLabelsWithPercentage () {
			if (!this.series.length) return this.labels
			const percentage = Array(this.labels.length).fill([])
			this.series.forEach((s, sIndex) => {
				if (!this.hiddenSeries.includes(sIndex) && s.data.length) {
					s.data.forEach((d, dIndex) => {
						if (this.series.length > 1) {
							percentage[dIndex] = [...percentage[dIndex], `${String(s.name[0]).toUpperCase()}:${d}%`]
						} else {
							percentage[dIndex] = [...percentage[dIndex], `${d}%`]
						}
					})
				}
			})

			return this.labels.map((label, index) => [label, percentage[index].join(', ')])
		},

		setLabels (chartContext, seriesIndex) {
			if (this.hiddenSeries.includes(seriesIndex)) {
				this.hiddenSeries = this.hiddenSeries.filter(i => i !== seriesIndex)
			} else {
				this.hiddenSeries = [...this.hiddenSeries, seriesIndex]
			}

			this.updateLabels()
		},

		init () {
			this.chartOptions = {
				chart: {
					toolbar: { show: false },
					events: {
						legendClick: this.setLabels
					}
				},
				stroke: { width: 1, colors: ['#A3A0FB', '#599ED9'] },
				fill: { colors: ['#A3A0FB4D', '#599ED94D'] },
				title: {
					text: this.title,
					margin: 0,
					style: {
						color: 'currentColor',
						fontWeight: 'normal',
						fontSize: '11px',
						fontFamily: 'Quicksand, sans-serif'
					}
				},
				animations: {
					easing: 'linear',
					speed: 500,
					animateGradually: { delay: 500 },
					dynamicAnimation: { speed: 500 }
				},
				legend: {
					show: true,
					showForSingleSeries: false,
					offsetY: 20,
					position: 'left',
					fontSize: '10px',
					markers: {
						fillColors: ['#A3A0FB', '#599ED9'],
						radius: 5,
						width: 18,
						height: 10
					},
					onItemHover: { highlightDataSeries: !this.autoUpdate },
					onItemClick: { toggleDataSeries: !this.autoUpdate }
				},
				markers: {
					size: this.autoUpdate ? 0 : 2,
					colors: ['#A3A0FB', '#599ED9'],
					hover: { sizeOffset: 1 }
				},
				tooltip: {
					enabled: !this.autoUpdate,
					style: { fontSize: '9px' },
					marker: { show: false },
					y: { formatter: (val) => val ? `${val}%` : 0 }
				},
				yaxis: {
					show: true,
					labels: {
						style: {
							fontSize: '8px',
							colors: 'currentColor'
						}
					}
				},
				xaxis: {
					categories: this.getLabelsWithPercentage(),
					labels: {
						offsetY: -7,
						style: {
							fontSize: '8px'
						}
					}
				},
				plotOptions: {
					radar: {
						size: this.plotSize,
						offsetY: -10
					}
				},
				noData: {
					text: this.noData,
					align: 'center',
					verticalAlign: 'middle',
					style: { fontSize: '10px' }
				}
			}
		},

		updateLabels () {
			this.$refs.chart.updateOptions({
				xaxis: {
					categories: this.getLabelsWithPercentage()
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.app-chart-radar {
	text-transform: capitalize;

	&.live { pointer-events: none; }
}
</style>



// WEBPACK FOOTER //
// src/components/app-components/AppChartRadar.vue